import React from 'react';
import { Company, PolicyType } from '../../types';
import { CompanyCard } from './CompanyCard';

interface CompanyGridProps {
  companies: Company[];
  onSelectCompany: (companyId: string, policyType: PolicyType) => void;
  onJobCreated?: (job: any) => void;
}

export const CompanyGrid: React.FC<CompanyGridProps> = ({
  companies,
  onSelectCompany,
  onJobCreated,
}) => {
  if (companies.length === 0) {
    return (
      <div className="bg-white dark:bg-slate-800 rounded-xl p-12 text-center border border-slate-200 dark:border-slate-700">
        <p className="text-slate-500 dark:text-slate-400 text-sm">
          No companies found matching your search filters.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {companies.map((company) => (
        <CompanyCard
          key={company.id}
          company={company}
          onSelect={onSelectCompany}
          onJobCreated={onJobCreated}
        />
      ))}
    </div>
  );
};
